// src/utils/ordersExport.ts
import type { OrdersTableOrder } from '../components/OrdersItemsFromNotifications';
import type { Notification as OrderNotif } from '../types/Notification';

// Ровно те же заголовки/порядок, что в OrdersItemsTable (L70–L88)
export const ORDERS_XLSX_COLUMNS = [
  { title: 'Номер заказа',  key: 'orderNumber' },
  { title: 'Дата',          key: 'date' },
  { title: 'Статус заказа', key: 'status' },
  { title: 'Тип товара',    key: 'itemType' },
  { title: 'SKU',           key: 'sku' },
  { title: 'Кол-во',        key: 'qty' },
  { title: 'Цена',          key: 'price' }, // число (без AMD)
  { title: 'Сумма',         key: 'total' }, // число (без AMD)
] as const;

export type OrdersRow = {
  orderNumber: string;
  date: string;              // формат ru-RU, как в таблице
  status: string;
  itemType: string;
  sku: string;
  qty: number;
  price: number | null;
  total: number | null;
};

// Плоский разворот позиций — идентично OrdersItemsTable (L31–L67)
export function mapOrdersToRows(orders: OrdersTableOrder[]): OrdersRow[] {
  const out: OrdersRow[] = [];
  for (const o of orders) {
    const date = new Date(o.createdAt).toLocaleString('ru-RU');
    const status = o.status ?? '—';
    const itemType = o.itemType ?? '—';
    const items = Array.isArray(o.items) ? o.items : [];

    if (items.length === 0) {
      out.push({
        orderNumber: o.orderNumber,
        date,
        status,
        itemType,
        sku: '—',
        qty: 0,
        price: null,
        total: null,
      });
    } else {
      items.forEach((it) => {
        out.push({
          orderNumber: o.orderNumber,
          date,
          status,
          itemType,
          sku: it.sku ?? '—',
          qty: Number(it.quantity ?? 0),
          price: it.price ?? null,
          total: it.total ?? null,
        });
      });
    }
  }
  return out;
}

// Адаптация уведомлений → OrdersTableOrder (как в OrdersItemsFromNotifications L42–L63)
export function mapNotifsToOrders(notifItems: OrderNotif[]): OrdersTableOrder[] {
  const mapped = (notifItems ?? []).map((n: any) => {
    const id = n?.id ?? n?.number;
    const orderNumber = n?.number ?? String(id ?? '');
    const createdAt = n?.createdAt ?? new Date().toISOString();
    const total = typeof n?.total === 'number' ? n.total : undefined;

    return {
      id,
      orderNumber,
      createdAt,
      status: n?.status ?? '—',
      itemType: n?.itemType ?? n?.type ?? '—',
      items: [
        {
          sku: n?.sku ?? '—',
          quantity: 1,
          price: total ?? null,
          total: total ?? null,
        },
      ],
    };
  });

  // по дате — новые сверху (как в компоненте)
  mapped.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
  return mapped;
}
